import React from "react";
import { Rotate3d, BaggageClaim } from "lucide-react";
import {
  DOCS_REMOTE_DATA_PATH,
  DOCS_PASSTHROUGH_REQUESTS_PATH,
} from "../../../../../router/RouterUtils";
import { Card, Text } from "@merge-api/merge-javascript-shared";
import FeatureCard from "../shared/FeatureCard";

const SupplementalData = () => {
  return (
    <Card className="p-6 mx-auto w-full lg:w-3/4">
      <Text variant="h3" className="mb-1">
        Supplemental data
      </Text>
      <Text as="p" className="mb-6 text-gray-40">
        Interact with original data from integrated third-party platforms
      </Text>
      <Text as="p">
        Merge normalizes integration data from different third-party platforms - each with its own
        data schema - into a standardized data model format ("Common Model") for a unified
        integration experience.
      </Text>
      <Text as="p">
        While the Common Model covers most use cases, some third-parties may have uncommon fields.
      </Text>
      <Text as="p">
        In these cases, you can leverage Merge's Unified API and SDK to interact with original data
        from integrated third-parties.
      </Text>
      <Text as="p" className="mb-9">
        Explore our two advanced capabilities below:
      </Text>

      <FeatureCard
        icon={<BaggageClaim size={16} />}
        title="Remote data"
        docsPath={DOCS_REMOTE_DATA_PATH}
      >
        <Text>
          Pull user data from integrated third-parties in its <b>original format</b> (before
          normalization). Professional and Enterprise plans only.
        </Text>
      </FeatureCard>

      <FeatureCard
        icon={<Rotate3d size={16} />}
        title="Passthrough requests"
        docsPath={DOCS_PASSTHROUGH_REQUESTS_PATH}
      >
        <Text>
          Use our <strong>Passthrough Requests</strong> to make any supported request
          (pre-authenticated) to an integration's API.
        </Text>
      </FeatureCard>
    </Card>
  );
};

export default SupplementalData;
